import type { QueryRollupLevelOption } from "./types";

export const getCatalogueValues = (
  options: ReadonlyArray<QueryRollupLevelOption>,
): readonly string[] => options.map((option) => option.value);

export const getNextLevelToAdd = (
  catalogueValues: readonly string[],
  selectedValues: readonly string[],
): string | null => catalogueValues.find((level) => !selectedValues.includes(level)) ?? null;
